import { useUpgradeModal } from "@/hooks/useUpgradeModal";
import { BillingUpgradeModal } from "./BillingUpgradeModal";

export function GlobalUpgradeModal() {
  const { isOpen, preselectedPlanId, mode, closeUpgradeModal } = useUpgradeModal();

  return (
    <BillingUpgradeModal
      forceShow={isOpen}
      onClose={closeUpgradeModal}
      preselectedPlanId={preselectedPlanId}
      mode={mode}
    />
  );
}
